/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SrsReviewInput = {
    lessonId: string;
    itemKind: SrsReviewInput.itemKind;
    itemId: string;
    front?: string;
    back?: string;
    /**
     * 1 again | 2 hard | 3 good | 4 easy
     */
    rating: number;
};
export namespace SrsReviewInput {
    export enum itemKind {
        FLASHCARD = 'flashcard',
        QUIZ = 'quiz',
    }
}

